import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Container } from '../components/ui';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import CTASection from '../components/CTASection';
import { CaseStudyCard } from '../components/cards';
import { fetchCaseStudies, resolveImg } from '../lib/marketingApi';

export default function CaseStudies() {
  const { t } = useLanguage();
  const [items, setItems] = useState(null);

  useEffect(() => {
    fetchCaseStudies().then((d) => setItems(d.items || [])).catch(() => setItems([]));
  }, []);

  return (
    <div>
      <PageHero
        eyebrow={t('nav.caseStudies')}
        title="Real outcomes, measurable impact"
        subtitle="Anonymised stories from BillPortal-managed portfolios — from multifamily operators to global commercial real estate."
      />
      <section className="px-5 py-16 sm:px-8 sm:py-20">
        <Container>
          {items === null ? (
            <div className="flex items-center justify-center py-24 text-slate-400"><Loader2 className="h-6 w-6 animate-spin" /></div>
          ) : items.length === 0 ? (
            <div className="py-24 text-center text-slate-400">No case studies published yet. Check back soon.</div>
          ) : (
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              {items.map((cs, i) => (<Reveal key={cs.slug} delay={i * 80}><CaseStudyCard cs={{ ...cs, image: resolveImg(cs.image) }} /></Reveal>))}
            </div>
          )}
        </Container>
      </section>
      <CTASection />
    </div>
  );
}
